import React from 'react';
import './uploadcta.css'
import pic53 from '../../assets/pic53.png'

const Uploadcta = (props) => {
    return ( 
        <button className='upload-ctaa' onClick={props.onClick}>
            <img src={pic53} alt='upload'></img>
            <h2 className='text-uploadd-cta'>{props.title}</h2>
        </button>
     );
}
 
export default Uploadcta;